import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";
import { chartThemeColors } from "./index";
import { FiBarChart2, FiTrendingUp } from "react-icons/fi";

const LineWidget = ({ data, heading, size, handleReq=null, url=null, loading=false }) => {
    const [formatData, setFormatData] = useState(null);
    const [branchData,setBranchData] = useState(null);
    const [chartType, setChartType] = useState('line');
    
    useEffect(() => {
      setBranchData([]);
      if(data?.date || data?.values){
        setFormatData(data.date);
        const finalData = [];
        data?.values && Object.keys(data.values).forEach((key, index) => {
          finalData.push({
              name: key,
              data: Object.values(data.values)[index],
          });
        });
        setBranchData(finalData);
      }else{
        setFormatData(null)
      }
    }, [data]);
      
  return (
    <div className={`col row mx-0 mt-3 ${size} px-2 position-relative`}>
      <div className="row px-0 mx-0 justify-content-between col col-12 ">
        <div className="dashboard__card col col-12 w-100 flex-basis-100">
          {heading ? (
            <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
              <h5 className="my-0 text-capitalize" style={{ fontWeight: 600, color: '#333' }}>{heading}</h5>
              {branchData && formatData && (
                <div className="d-flex align-items-center" style={{ gap: '2px', background: '#e9ecef', padding: '2px', borderRadius: '16px' }}>
                  <div 
                    className="d-flex justify-content-center align-items-center rounded-circle" 
                    style={{ width: '24px', height: '24px', cursor: 'pointer', transition: 'all 0.2s', background: chartType === 'line' ? '#fff' : 'transparent', boxShadow: chartType === 'line' ? '0 1px 3px rgba(0,0,0,0.15)' : 'none' }}
                    onClick={() => setChartType('line')}
                    title="Line Chart"
                  >
                    <FiTrendingUp size={14} color={chartType === 'line' ? '#0d6efd' : '#495057'} />
                  </div>
                  <div 
                    className="d-flex justify-content-center align-items-center rounded-circle" 
                    style={{ width: '24px', height: '24px', cursor: 'pointer', transition: 'all 0.2s', background: chartType === 'bar' ? '#fff' : 'transparent', boxShadow: chartType === 'bar' ? '0 1px 3px rgba(0,0,0,0.15)' : 'none' }}
                    onClick={() => setChartType('bar')}
                    title="Bar Chart"
                  >
                    <FiBarChart2 size={14} color={chartType === 'bar' ? '#0d6efd' : '#495057'} />
                  </div>
                </div>
              )}
            </div>
          ) : ""}
          <div className="d-flex flex-col mx-3 my-2" style={{ gap: "1rem" }}>
          </div>
          {branchData && formatData ? (
            <Chart
              width="100%"
              height="300px"
              type={chartType}
              series={branchData}
              options={{
                chart: {
                  type: chartType,
                  toolbar: {
                    show: false
                  },
                  animations: { enabled: true, easing: 'easeinout', speed: 800 }
                },
                markers: {
                    size: [5, 5]
                },
                stroke: {
                    curve: 'smooth',
                  },
                plotOptions: {
                  bar: {
                    distributed: false,
                    borderRadius: 5,
                  },
                },
                colors: chartThemeColors,
                dataLabels: {
                  enabled: false,
                },
                tooltip: {/*
                  enabled: true,
                  custom: ({ series, seriesIndex, dataPointIndex }) =>
                  console.log("abcd44",seriesIndex,series,dataPointIndex)
                    `<div class='bar-widget__tooltip'>
                <p class='bar-widget__tooltip-primary'>${
                    formatData.bar[dataPointIndex].value_formatted
                    ? parseFloat(formatData.bar[dataPointIndex].value_formatted)?.toFixed(2)
                    : parseFloat(formatData.bar[dataPointIndex].value)?.toFixed(2)
                }</p>
                
                </div>`,
              */},
                xaxis: {
                  categories: formatData?.map(date => date),
                  labels: { 
                    show: true,
                    style:{
                      fontSize:"10.5px"
                    }
                  },
                },
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return value ? value?.toFixed(0) : value;
                    },
                    style:{
                      fontSize:"10.5px"
                    }
                  },
                  tickAmount: 4,
                },
                legend:{
                  position:"top",
                  fontSize:"10.5px",
                  offsetY:0,
                }
              }}
            />
          ):(
            <div className="btn_load btn_load_radial">
              {
                loading ? (
                  <>
                    {/*loading */}
                    <CustomSpinLoader loading={loading}/>
                  </>
                ) : (
                  <button className="btn btn-sm btn-primary rounded-md" onClick={()=>url && handleReq(url)}>Load Data</button>
                ) 
              }
            </div>
          )}
        
        </div>
      </div>
    </div>
  )
}

export default LineWidget
